module.exports = __webpack_public_path__ + "static/media/arrowBottomGreen.4fdc9c79.svg";